import { twMerge } from 'tailwind-merge';

export function Heading({
  heading,
  headingClassName,
  subheading,
  subheadingClassName,
  xl,
  large,
  hero,
  medium,
  small,
  ...props
}) {
  return (
    <div {...props}>
      {heading && (
        <h1
          className={twMerge(
            'font-light mb-1 leading-tight text-base-content',
            // small: ~24px mobile → ~32px desktop
            small && 'text-[1.5rem]/[1.85rem] md:text-[2rem]/[2.4rem]',
            // medium: ~30px mobile → ~42px desktop
            medium && 'text-[1.875rem]/[2.25rem] md:text-[2.625rem]/[3rem]',
            // hero: ~36px mobile → ~42px desktop (onboarding and flow entries)
            hero && 'text-[2.25rem]/[2.7rem] md:text-[2.625rem]/[3rem]',
            // large: ~40px mobile → ~52px desktop
            large && 'text-[2.5rem]/[3rem] md:text-[3.25rem]/[3.65rem]',
            // xl: ~44px mobile → ~56px desktop
            xl && 'text-[2.75rem]/[3.3rem] md:text-[3.5rem]/[4rem]',
            headingClassName
          )}
        >
          {heading}
        </h1>
      )}
      {subheading && (
        <h2
          className={twMerge(
            'font-light text-muted leading-tight',
            small && 'text-sm md:text-base',
            medium && 'md:text-base',
            hero && 'md:text-base',
            large && 'text-base md:text-lg',
            xl && 'text-base md:text-xl',
            subheadingClassName
          )}
        >
          {subheading}
        </h2>
      )}
    </div>
  );
}
